import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {HelperService} from "app/lib/helper.service";
import {ChartParams} from "app/views/chart/chart.component";
import {BaseComponent} from "app/views/base.component";
import {EventsService} from "app/lib/EventsService";
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import {PaidDetailsComponent} from "../../views/modal/paid_details/paid_details.component";
import {ModalService} from "../../views/modal/base_modal.component";

import dictionary from "dict/static.json";
import { BillingService2 } from "../billing.service";
import { FilterParams } from "../../models/filter_form.model";

@Component({
	selector: 'promocodes-report',
	templateUrl: './promocode.component.html'
})
export class PromocodeComponent extends BaseComponent {
	addFilterParams = {
		userType      : 'user',
		chartDateType : 'promocode',
		promocodeMark : '',
		dateFilters   : ['datePaid', 'dateCreated', 'dateSiteCreated'],
		isPromocode   : true
	};
	
	promocodeChartData = new ChartParams();
	flashPromoChartData = new ChartParams();
	
	promocodeApplyLimit = 200;
	flashPromoLimit = 24;
	
	stats = [];
	statsLoader: boolean = false;
	
	siteList = {};
	tariffList = {};
	
	sitesLoader = {};
	tariffsLoader = {};

	public currencyList;

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public filter: FilterFormService,
		public modalService: ModalService,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);

		this.filter.addFilters.push('promocode');

		this.currencyList = dictionary.currencyList;
	}
	
	
	async getData() {
		this.siteList = [];
		this.tariffList = [];
		this.sitesLoader = {};
		
		await this.getPromocodeChart();
		await this.getFlashPromoChart();
		await this.getStats();
	}
	
	
	async getPromocodeChart() {
		this.promocodeChartData.showLoader();
		
		const { charts: data } = await this.service2.promocode.barChart(
			this.filter.getCopyFilterParams(
				<FilterParams>{ promocodeApplyLimit : this.promocodeApplyLimit }
			)
		).toPromise();
		
		let barData = [
			this.translate.__A('billing._promocode.use code')
		];
		
		for(let i=0; i<=this.promocodeApplyLimit; i++) {
			barData.push(
				data[i] || '0'
			);
		}
		
		this.promocodeChartData.setOptions({
			type: 'bar',
			grid: {
				y: {
					lines: [{value: 0}]
				}
			},
			axis: {
				x: {
					type: 'category',
					tick: {
						culling: {
							max: 10
						}
					}
				}
			}
		});
		this.promocodeChartData.data = [barData];
		
		this.promocodeChartData.hideLoader();
	}
	
	
	async onPromocodeApplyLimitChange() {
		await this.getPromocodeChart();
	}
	
	
	async getFlashPromoChart() {
		this.flashPromoChartData.showLoader();
		
		const { charts: data } = await this.service2.promocode.barChart(
			this.filter.getCopyFilterParams(
				<FilterParams>{ promocodeApplyLimit : this.flashPromoLimit }
			),
			'flash_charts'
		).toPromise();
		
		let barData = Object.keys(data).map(function(t) { return data[t]; });
		barData.unshift(this.translate.__A('billing._promocode.flashpromo (by hours)'));
		
		this.flashPromoChartData.setOptions({
			type: 'bar',
			grid: {
				y: {
					lines: [{value: 0}]
				}
			},
			axis: {
				x: {
					type: 'category',
					tick: {
						culling: {
							max: 10
						}
					}
				}
			}
		});
		this.flashPromoChartData.data = [barData];
		
		this.flashPromoChartData.hideLoader();
	}
	
	
	async onFlashPromoApplyLimitChange() {
		await this.getFlashPromoChart();
	}
	
	
	async getStats() {
		this.statsLoader = true;
		const { stats } = await this.service2.promocode.stats(
			this.filter.filterParams
		).toPromise();
		this.stats = stats;
		
		this.statsLoader = false;
	}
	
	
	async onOpenSites($event: NgbPanelChangeEvent, mark: string) {
		if (this.siteList[mark]) return true;
		
		if (typeof this.sitesLoader[mark] == 'undefined') {
			this.sitesLoader[mark] = true;
		} else {
			this.sitesLoader[mark] = !this.sitesLoader[mark];
		}
		
		if (this.sitesLoader[mark]) {
			const { stats } = await this.service2.promocode.stats(
				{ ...this.filter.filterParams, mark },
				'sites'
			).toPromise();
			this.siteList[mark] = stats;
			
			this.sitesLoader[mark] = false;
		}
	}
	
	
	async onOpenTariffs($event: NgbPanelChangeEvent, mark: string) {
		if (this.tariffList[mark]) return true;
		
		if (typeof this.tariffsLoader[mark] == 'undefined') {
			this.tariffsLoader[mark] = true;
		} else {
			this.tariffsLoader[mark] = !this.tariffsLoader[mark];
		}
		
		if (this.tariffsLoader[mark]) {
			const { stats } = await this.service2.promocode.stats(
				{ ...this.filter.filterParams, mark },
				'tariffs'
			).toPromise();
			this.tariffList[mark] = stats;
			
			this.tariffsLoader[mark] = false;
		}
	}
	
	
	async showPaidDetails(siteData) {
		const modalRef = this.modalService.open(PaidDetailsComponent, {
			title: siteData.domainUrl,
			params: this.filter.filterParams,
		}, {size: 'hg'});
		
		const { stats } = await this.service2.siteBilling.detail(
			{ ...this.filter.filterParams, siteIds: [siteData._id] }
		).toPromise();

		modalRef.componentInstance.details = stats;
	}
}


